var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCredits16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73244 9C9.38663 9.5978 8.74028 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C8.74028 6 9.38663 6.4022 9.73244 7H11.874C11.4299 5.27477 9.86384 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C9.86384 12 11.4299 10.7252 11.874 9H9.73244Z",
    fill: "#18191B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCredits16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;